import { render, staticRenderFns } from "./PeruutaHyvaksyPainikerivi.vue?vue&type=template&id=2ff5768c&"
import script from "./PeruutaHyvaksyPainikerivi.vue?vue&type=script&lang=js&"
export * from "./PeruutaHyvaksyPainikerivi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ff5768c')) {
      api.createRecord('2ff5768c', component.options)
    } else {
      api.reload('2ff5768c', component.options)
    }
    module.hot.accept("./PeruutaHyvaksyPainikerivi.vue?vue&type=template&id=2ff5768c&", function () {
      api.rerender('2ff5768c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PeruutaHyvaksyPainikerivi.vue"
export default component.exports